import axios from "axios";
import { API } from "./apiClient";

const http = axios.create({ baseURL: API, withCredentials: true });

const REVIEW_FIELDS = `
  id destination_id rating text tags created_at updated_at
  author { id name }
  helpful_count
  viewer_has_helpful
`;

const execute = async (query, variables) => {
  const response = await http.post("", { query, variables });
  if (response.data.errors?.length) throw new Error(response.data.errors[0].message);
  return response.data.data;
};

export const applyHelpfulResult = (reviews, result) =>
  (reviews || []).map((review) => review.id === result.review_id
    ? { ...review, helpful_count: result.helpful_count, viewer_has_helpful: result.helpful }
    : review);

export async function fetchDestinationCommunityReviews(destinationId) {
  const data = await execute(
    `query DestinationCommunityReviews($destinationId: ID!) {
      destinationReviews(destination_id: $destinationId) {
        summary { average count }
        reviews { ${REVIEW_FIELDS} }
      }
    }`,
    { destinationId },
  );
  return data.destinationReviews;
}

export async function setReviewHelpful(reviewId, helpful) {
  const data = await execute(
    `mutation SetReviewHelpful($reviewId: ID!, $helpful: Boolean!) {
      setReviewHelpful(review_id: $reviewId, helpful: $helpful) {
        review_id helpful helpful_count
      }
    }`,
    { reviewId, helpful },
  );
  return data.setReviewHelpful;
}
